(function () {
  'use strict';
  // Catalog dates must not depend on browser support for input[type=month].
  // Visible dropdowns always produce the same YYYY-MM value on every browser.
  const monthNames = ['January','February','March','April','May','June',
    'July','August','September','October','November','December'];
  function normalizeCatalogMonth(value) {
    const raw = String(value ?? '').trim().replace(/\s+/g, ' ');
    let match = raw.match(/^(\d{4})-(\d{1,2})(?:-01)?$/);
    let year = match?.[1];
    let month = match ? Number(match[2]) : 0;
    if (!match) {
      match = raw.match(/^(\d{1,2})\/(\d{4})$/);
      if (match) { month = Number(match[1]); year = match[2]; }
    }
    if (!match) {
      match = raw.match(/^([a-z]+)\.?[ ,]+(\d{4})$/i);
      if (match) {
        const label = match[1].toLowerCase();
        month = monthNames.findIndex(name => name.toLowerCase() === label ||
          name.slice(0,3).toLowerCase() === label || (name === 'September' && label === 'sept')) + 1;
        year = match[2];
      }
    }
    // Never infer a year from a filename, today's date, or a bare month name.
    return /^\d{4}$/.test(String(year || '')) && Number(year) >= 1000 &&
      month >= 1 && month <= 12 ? year + '-' + String(month).padStart(2,'0') : '';
  }
  function readCatalogMonth(form, selector) {
    const input = form.querySelector(selector);
    if (!input) return '';
    const group = input.closest('[data-aa-catalog-period]');
    const value = group ? normalizeCatalogMonth(
      (group.querySelector('[data-aa-catalog-year]')?.value || '') + '-' +
      (group.querySelector('[data-aa-catalog-month-number]')?.value || '')
    ) : normalizeCatalogMonth(input.value);
    if (group || value) input.value = value;
    return value;
  }
  function enhanceCatalogMonth(html, selector) {
    const template = document.createElement('template');
    template.innerHTML = html;
    const input = template.content.querySelector(selector);
    const label = input?.closest('label');
    if (!input || !label || input.closest('[data-aa-catalog-period]')) return html;
    const initial = normalizeCatalogMonth(input.getAttribute('value') || input.value);
    const currentYear = new Date().getFullYear();
    const selectedYear = initial ? Number(initial.slice(0,4)) : currentYear;
    const selectedMonth = initial ? initial.slice(5,7) : '';
    const group = document.createElement('fieldset');
    group.setAttribute('data-aa-catalog-period', '1');
    group.style.cssText = 'min-width:0;border:0;margin:0;padding:0;display:block;';
    const legend = document.createElement('legend');
    legend.textContent = 'Catalog Month';
    legend.style.cssText = 'padding:0;margin:0 0 8px;font:inherit;font-weight:700;';
    group.appendChild(legend);
    const grid = document.createElement('div');
    grid.style.cssText = 'display:grid;grid-template-columns:minmax(0,1.5fr) minmax(0,1fr);gap:10px;';
    function selectField(text, attribute, choices, selected) {
      const fieldLabel = document.createElement('label');
      fieldLabel.style.cssText = 'display:grid;gap:6px;min-width:0;';
      const title = document.createElement('span'); title.textContent = text;
      const select = document.createElement('select');
      select.setAttribute(attribute, '');
      select.required = true;
      select.style.cssText = 'width:100%;min-width:0;min-height:40px;font:inherit;';
      for (const [value, caption] of choices) {
        const option = document.createElement('option');
        option.value = String(value); option.textContent = caption;
        if (String(value) === String(selected)) option.setAttribute('selected', '');
        select.appendChild(option);
      }
      fieldLabel.append(title, select); grid.appendChild(fieldLabel);
    }
    selectField('Month', 'data-aa-catalog-month-number', [['','Choose month'],
      ...monthNames.map((name,i) => [String(i+1).padStart(2,'0'), name])], selectedMonth);
    const years = new Set(Array.from({length:33}, (_,i) => currentYear+2-i));
    years.add(selectedYear); // Older saved catalogs keep their original year.
    selectField('Year', 'data-aa-catalog-year', [['','Choose year'],
      ...[...years].sort((a,b)=>b-a).map(year => [String(year),String(year)])], selectedYear);
    group.appendChild(grid);
    const hidden = input.cloneNode(false);
    hidden.type = 'hidden';
    hidden.removeAttribute('required');
    hidden.removeAttribute('min'); hidden.removeAttribute('max'); hidden.removeAttribute('pattern');
    hidden.value = initial;
    hidden.setAttribute('data-aa-catalog-month-value', '');
    group.appendChild(hidden);
    const help = document.createElement('small');
    help.textContent = 'Choose the catalog month and year.';
    help.style.cssText = 'display:block;margin-top:8px;font-size:12px;font-weight:400;line-height:1.5;';
    group.appendChild(help);
    label.replaceWith(group);
    return template.innerHTML;
  }
  window.AACatalogMonth = Object.freeze({
    normalize: normalizeCatalogMonth, read: readCatalogMonth, enhance: enhanceCatalogMonth
  });
  if (!document.__aaCatalogMonthBound) {
    document.__aaCatalogMonthBound = true;
    document.addEventListener('change', event => {
      if (!event.target?.matches?.('[data-aa-catalog-month-number],[data-aa-catalog-year]')) return;
      const group = event.target.closest('[data-aa-catalog-period]');
      if (group) readCatalogMonth(group, '[data-aa-catalog-month-value]');
    });
  }

  const Cls = window.AAHeadquartersClients;
  const api = window.AASupabaseClient;
  if (!Cls?.prototype || !api || Cls.prototype.__aaCatalogSafeSave) return;
  const proto = Cls.prototype;

  const originalCatalogForm = proto.renderCatalogForm;
  if (typeof originalCatalogForm === 'function') {
    proto.renderCatalogForm = function (...args) {
      return enhanceCatalogMonth(originalCatalogForm.apply(this, args),
        '[data-aa-catalog-field="catalogMonth"]');
    };
  }

  // Handle Save in capture phase. Never allow a catalog form to navigate
  // natively or lose the selected PDF, even when the old handler is delayed.
  const previousBind = proto.bindClientActions;
  proto.bindClientActions = function () {
    previousBind.call(this);
    const host = this.root;
    if (host.__aaCatalogSaveCaptureBound) return;
    host.__aaCatalogSaveCaptureBound = true;

    const intercept = (event) => {
      const target = event.target;
      if (!target?.closest) return;
      const button = event.type === 'click'
        ? target.closest('[data-aa-save-catalog],[data-aa-catalog-header-save]') : null;
      if (event.type === 'click' && !button) return;
      if (event.type !== 'click' && event.type !== 'submit') return;
      const form = button?.form || target.closest('[data-aa-catalog-form]');
      if (!form?.matches('[data-aa-catalog-form]') || !host.contains(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      void this.saveCatalogSafely(form);
    };
    host.addEventListener('click', intercept, true);
    host.addEventListener('submit', intercept, true);
  };

  proto.saveCatalogSafely = async function (form) {
    if (this.__aaCatalogSaving) return;
    const clientId = form.dataset.aaCatalogForm;
    const editingId = form.dataset.aaCatalogEditId || '';
    const client = this.clients.find(x => String(x.id) === String(clientId));
    const submit = form.querySelector('[data-aa-save-catalog]');
    if (!submit) return;

    let info = form.querySelector('[data-aa-catalog-save-progress]');
    if (!info) {
      info = document.createElement('p');
      info.setAttribute('data-aa-catalog-save-progress', '');
      info.setAttribute('role', 'status');
      info.setAttribute('aria-live', 'polite');
      info.style.cssText = 'flex-basis:100%;margin:8px 0;color:inherit;font-weight:600;';
      (submit.parentElement || form).appendChild(info);
    }
    const updateStatus = message => { info.textContent = message; };

    if (!client) {
      updateStatus('This client could not be confirmed. Open the client again before saving.');
      return;
    }
    if (String(this.activeClientId) !== String(clientId)) {
      updateStatus('Client selection changed. Reopen the catalog form to avoid saving to the wrong client.');
      return;
    }
    const get = name => form.querySelector('[data-aa-catalog-field="' + name + '"]')?.value || '';
    const month = readCatalogMonth(form, '[data-aa-catalog-field="catalogMonth"]');
    if (!month) {
      updateStatus('Choose both a Month and a Year for this catalog.');
      return;
    }
    const pdfInput = form.querySelector('[data-aa-catalog-pdf]');
    const chosenFile = pdfInput?.files?.[0] || null;
    if (!editingId && !chosenFile) {
      updateStatus('Choose the catalog PDF before saving.');
      return;
    }
    let pdfFile = chosenFile;
    if (pdfFile) {
      if (!/\.pdf$/i.test(pdfFile.name || '')) {
        updateStatus('The catalog file must be a PDF.');
        return;
      }
      if (pdfFile.size > 75 * 1024 * 1024) {
        updateStatus('The PDF is too large. Maximum file size is 75 MB.');
        return;
      }
      // Some browsers supply an empty or application/octet-stream MIME type.
      // The validated PDF extension and type correction make uploads work there.
      if (pdfFile.type !== 'application/pdf') {
        if (typeof File !== 'function') {
          updateStatus('This browser could not identify the PDF file. Try another browser.');
          return;
        }
        pdfFile = new File([pdfFile], pdfFile.name, {type:'application/pdf',lastModified:pdfFile.lastModified});
      }
    }

    const viewsValue = String(get('catalogViews')).trim();
    const views = viewsValue ? Number(viewsValue) : null;
    if (views !== null && (!Number.isInteger(views) || views < 0)) {
      updateStatus('Catalog Views must be zero or a positive whole number.');
      return;
    }
    const selectedBrands = Array.from(form.querySelectorAll('[data-aa-catalog-brand]:checked'))
      .map(x => String(x.value || '').trim()).filter(Boolean);
    const additional = String(form.querySelector('[data-aa-catalog-additional-brands]')?.value || '')
      .split(',').map(x => x.trim()).filter(Boolean);
    const brands = [...new Set([...selectedBrands,...additional])];

    this.__aaCatalogSaving = true;
    submit.disabled = true;
    const normalButtonText = submit.textContent;
    submit.textContent = 'Saving...';

    let savedRecord = null;
    try {
      updateStatus('Checking existing catalog records...');
      const existing = await api.getCatalogRecords({clientId});
      if (!Array.isArray(existing)) throw new Error('Could not verify existing catalog records.');
      const targetMonth = month + '-01';
      if (existing.some(x => String(x.catalog_month || '').slice(0,10) === targetMonth &&
            String(x.id) !== String(editingId))) {
        throw new Error('A catalog for this month already exists. Edit that catalog instead.');
      }
      const current = editingId ? existing.find(x => String(x.id) === String(editingId)) : null;
      if (editingId && !current) throw new Error('The catalog being edited was not found. Reopen it from Catalog History.');

      let uploaded = null;
      if (pdfFile) {
        updateStatus('Uploading PDF. Keep this page open...');
        uploaded = await api.uploadCatalogPdf({clientId,file:pdfFile});
        if (!uploaded?.path) throw new Error('The PDF upload did not return a storage path.');
      }

      updateStatus('Saving catalog record...');
      const details = {
        catalogMonth:month, publicationDate:targetMonth,
        catalogTitle:current?.catalog_title || this.formatCatalogMonth(targetMonth) + ' Catalog',
        catalogUrl:current?.catalog_url || '',
        catalogViews:views, brands
      };
      if (uploaded) {
        details.catalogPdfStoragePath=uploaded.path;
        details.catalogPdfFileName=uploaded.fileName;
        details.catalogPdfFileSize=uploaded.fileSize;
        details.catalogPdfUploadedAt=new Date().toISOString();
      }
      if (editingId) {
        savedRecord = await api.updateCatalogRecord({id:editingId,updates:details});
      } else {
        savedRecord = await api.createCatalogRecord({clientId,...details});
      }
      if (!savedRecord?.id) throw new Error('Catalog save did not return a saved record.');

      // The catalog is committed. Do not wait for optional PDF cover conversion.
      client.catalog_records = [
        savedRecord,
        ...(Array.isArray(client.catalog_records) ? client.catalog_records : [])
          .filter(x => String(x.id) !== String(savedRecord.id))
      ].sort((a,b) => String(b.catalog_month || '').localeCompare(String(a.catalog_month || '')));
      this.addingCatalogClientId = null;
      this.editingCatalogId = null;
      this.activeClientId = clientId;
      this.render();
      this.showStatusMessage('Catalog saved successfully. PDF and catalog details are stored.');

      // Refresh the list and derive a cover without risking the saved PDF.
      void (async () => {
        try {
          const rows = await api.getCatalogRecords({clientId});
          if (Array.isArray(rows)) {
            const target = this.clients.find(x=>String(x.id)===String(clientId));
            if (target) {
              target.catalog_records = rows.some(x=>String(x.id)===String(savedRecord.id))
                ? rows : [savedRecord, ...rows];
              if (String(this.activeClientId)===String(clientId) &&
                  !this.addingCatalogClientId && !this.editingCatalogId) this.render();
            }
          }
        } catch(e) { console.warn('Catalog saved but history refresh failed:',e); }
        if (!pdfFile) return;
        try {
          const cover = await this.createCatalogCoverFromPdf({clientId,file:pdfFile});
          if (cover?.publicUrl) {
            await api.updateCatalogRecord({id:savedRecord.id,updates:{coverImageUrl:cover.publicUrl}});
            const target = this.clients.find(x=>String(x.id)===String(clientId));
            const record = target?.catalog_records?.find(x=>String(x.id)===String(savedRecord.id));
            if (record) record.cover_image_url = cover.publicUrl;
            if (String(this.activeClientId)===String(clientId) &&
                !this.addingCatalogClientId && !this.editingCatalogId) this.render();
          }
        } catch(e) {
          console.warn('Catalog saved; automatic cover generation failed:', e);
          // Saving the PDF never depends on optional cover processing.
        }
      })();
    } catch(error) {
      console.error('Catalog save failed before database confirmation:',error);
      updateStatus('Catalog was NOT saved: ' + (error?.message || 'Unknown error. Please try again.'));
      this.showStatusMessage('Catalog was not saved. ' + (error?.message || 'Check the form and try again.'),'error');
    } finally {
      this.__aaCatalogSaving = false;
      if (submit.isConnected) {
        submit.disabled = false;
        submit.textContent = normalButtonText;
      }
    }
  };

  proto.__aaCatalogSafeSave = true;
})();